import React, { useState, useRef } from 'react';
import { AlmeAppUtilsBase } from "../../AlmeApp/AlmeAppState";
import ConfirmDialog from '../../AlmeDialog/ConfirmDialog';
import IconButton from '../../AlmeUtilities/Icons/IconButton';
import postMessage from '../../../post-message/PostMessageUtils';
import { CloseContainer } from './AlmeClose.styles';
import { TerminateLiveChat } from "../../LiveChat/AlmeLiveChatReportingEvents";
import { isRCPostLoginMobile } from '../../../platform/identifiers';
const AlmeClose = (props) => {
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const returnFocusToElement = useRef(null);
    const handleCancelClose = () => {
        setTimeout(() => {
            var _a;
            (_a = returnFocusToElement.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 10);
        setOpenConfirmDialog(false);
        props.setIsDialogOpen(false);
    };
    const handleClose = () => {
        setOpenConfirmDialog(false);
        props.onCloseClick();
        props.setIsDialogOpen(false);
    };
    const handleClickOpen = () => {
        if (props.isSessionExpired) {
            props.onCloseClick();
        }
        else {
            returnFocusToElement.current = document.activeElement;
            setOpenConfirmDialog(true);
            props.setIsDialogOpen(true);
        }
    };
    if (!props.almeAppConfig.header.isCloseEnabled) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(CloseContainer, null,
            React.createElement(IconButton, Object.assign({ id: 'alme-close', className: 'alme--window--header--toolbar--close', "aria-label": "Close chat window", title: "Close chat window", iconType: "CloseButton", size: 20, onClick: handleClickOpen, type: "button" }, props.focusProps))),
        openConfirmDialog
            ? React.createElement(ConfirmDialog, { id: "alme-close-dialog", ariaLabelledBy: "alme-close-dialog-title", ariaDescribedBy: "alme-close-dialog-description", isOpen: openConfirmDialog, yesLabel: 'Yes', noLabel: 'No', onYes: handleClose, onNo: handleCancelClose, title: 'End Chat', description: 'Are you sure you want to end this chat?', height: 250, returnFocusToElement: returnFocusToElement.current })
            : null));
};
export default AlmeClose;
export class AlmeCloseUtils extends AlmeAppUtilsBase {
    endConversation() {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.apiUtils.endConversation();
    }
    constructor(almeState, setAlmeState, appConfig, apiUtils, clearSessionData) {
        super(almeState, setAlmeState, appConfig);
        this.apiUtils = apiUtils;
        this.clearSessionData = clearSessionData;
    }
    async onCloseClick() {
        if (this.almeState.isLiveChatConnected) {
            await TerminateLiveChat(this.apiUtils, this.almeState);
        }
        this.clearSessionData();
        this.setAlmeState(Object.assign(Object.assign({}, this.almeState), { isOpen: false, history: [], isLoggedIn: false, clientSessionId: undefined, hasPreviousConversation: false, sessionExpired: false, lastActivityTime: undefined, isLiveChatConnected: false, isInitialAppEventsSent: false }));
        if (this.appConfig.main.platform === "PSCC" || isRCPostLoginMobile()) {
            postMessage({
                type: 'IsClosed',
                source: 'nit',
            });
        }
        this.endConversation();
    }
}
